export enum EHttpMethod {
  GET = 'GET',
  HEAD = 'HEAD',
  POST = 'POST',
  PUT = 'PUT',
  PATCH = 'PATCH',
  DELETE = 'DELETE',
  OPTIONS = 'OPTIONS',
}

export enum EHttpStatus {
  SUCCESS = 200,
  BAD_REQUEST = 400,
  NOT_FOUND = 404,
  UNPROCESSABLE_ENTITY = 422,
  INTERNAL_SERVER_ERROR = 500,
  SERVICE_UNABAILABLE = 503,
}

export type TParamsRequest = {
  method: EHttpMethod
  headers?: Record<string, string>
  host: string | unknown
  pathname: string | unknown
  data?: unknown
  params?: unknown
  engine?: string
}

export type TResponseType<T> = {
  status: number
  data: T
  headers: Record<string, string>
}

export type TPayloadCallbacks<TSuccessData = unknown, TErrorData = unknown> = {
  success?: (data: TSuccessData) => void
  error?: (error: TErrorData) => void
  finally?: () => void
}
